import React from 'react'
import Router, {useRouter} from 'next/router'
import Link from 'next/link'
import classNames from 'classnames'

import {logEvent} from '@lib/gtm'
import {useScrollInfo} from '@lib/hooks'
import {LogoDataWow} from '@components/Logo'

const NAV_ITEMS = [
  {
    label: 'Service',
    href: '/services',
    hasDropdown: true,
    subMenus: [
      {label: 'Data Labeling', href: '/services/data-labeling'},
      {label: 'Custom AI', href: '/custom-ai'},
    ],
  },
  {
    label: 'Use Case',
    href: '/cases',
    hasDropdown: false,
  },
  {
    label: 'Company',
    href: '/about',
    hasDropdown: true,
    subMenus: [
      {label: 'About Us', href: '/about'},
      {label: 'Careers', href: '/careers'},
    ],
  },
  {
    label: 'Resource',
    href: '/blogs',
    hasDropdown: true,
    subMenus: [
      {label: 'Blog', href: '/blogs'},
      {label: 'Products', href: '/products'},
      {label: 'Demo', href: '/demo'},
    ],
  },
  {
    label: 'Contact',
    href: '/contact',
    hasDropdown: false,
  },
]

const LandingNav = () => {
  const router = useRouter()
  const [showMenu, setShowMenu] = React.useState(false)
  const {currentScrollPos, direction} = useScrollInfo()

  React.useEffect(() => {
    setShowMenu(false)
  }, [currentScrollPos])

  React.useEffect(() => {
    let mounted = true
    Router.events.on('routeChangeStart', () => {
      mounted && setShowMenu(false)
    })
    return () => {
      mounted = false
    }
  }, [])

  return (
    <header
      className={classNames('LandingNav', {
        'LandingNav--hide': currentScrollPos > 0 && direction === 'down',
        'LandingNav--scroll': currentScrollPos > 0,
      })}
    >
      <div className='LandingNav__container'>
        <button
          className='LandingNav__toggle'
          onClick={() => setShowMenu((s) => !s)}
          aria-label='Toggle menu'
        >
          <img src='/images/menu.svg' alt='Menu' />
        </button>

        <Link href='/'>
          <a
            className='LandingNav__logo'
            title='datawow.io'
            onClick={() => {
              logEvent({
                ga: {category: 'Homepage', action: 'Click Homepage'},
              })
            }}
          >
            <LogoDataWow />
          </a>
        </Link>

        <nav
          className={classNames('LandingNav__links', {
            'LandingNav__links--show': showMenu,
          })}
          onClick={(e) => {
            if (e.target.tagName === 'A') setShowMenu(false)
          }}
        >
          {NAV_ITEMS.map(({label, href, hasDropdown, subMenus}, index) => (
            <div key={`nav-${index}`} className='LandingNav__item'>
              {href ? (
                <Link href={href}>
                  <a className='LandingNav__a' title={label}>
                    {label}
                    {hasDropdown && (
                      <img
                        className='LandingNav__caret'
                        src='/images/arrow-down.svg'
                        alt=''
                        width='10'
                        height='6'
                      />
                    )}
                  </a>
                </Link>
              ) : (
                <span className='LandingNav__a'>
                  {label}
                  {hasDropdown && (
                    <img
                      className='LandingNav__caret'
                      src='/images/arrow-down.svg'
                      alt=''
                      width='10'
                      height='6'
                    />
                  )}
                </span>
              )}
              {subMenus && (
                <div className='LandingNav__submenu'>
                  {subMenus.map((sub) => (
                    <Link key={sub.href} href={sub.href} passHref>
                      <a className='LandingNav__submenu__a' title={sub.label}>
                        {sub.label}
                      </a>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        <div className='LandingNav__right'>
          <Link href='/contact'>
            <a className='LandingNav__cta'>Get in Touch</a>
          </Link>
        </div>
      </div>
    </header>
  )
}

export default LandingNav
